import api from "./api";

class VoceSpesaBusinessUnitIvaManager {

    vociSpesaBusinessUnitIva(config?: any) {
        return api.get(`/voci_spesa_business_unit_iva`, config)
    }

    voceSpesaBusinessUnitIva(id: number | string) {
        return api.get(`/voci_spesa_business_unit_iva/${id}`)
    }

    update(id: number | string, data:any) {
        return api.put(`/voci_spesa_business_unit_iva/${id}`, data)
    }

    create(data:any) {
        return api.post(`/voci_spesa_business_unit_iva`, data)
    }

    delete(id: number | string) {
        return api.delete(`/voci_spesa_business_unit_iva/${id}`)
    }

    list = this.vociSpesaBusinessUnitIva
    retrieve = this.voceSpesaBusinessUnitIva
    paginatedList = this.list
}

const voceSpesaBusinessUnitIvaManager = new VoceSpesaBusinessUnitIvaManager()

export default voceSpesaBusinessUnitIvaManager
